import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { capitalize, formatPrice } from '@winelidays/wld-tsx-2/utils';
import { useMemo } from 'react';
import PracticalLine from '../../PracticalLine';
const ExperienceExtra = ({ extra }) => {
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    const priceContent = useMemo(() => translate('practical.price_range.unique', {
        price: formatPrice(extra.price),
        currencySymbol
    }), [translate, extra, currencySymbol]);
    return (<PracticalLine label={extra.name} content={<span className="align-baseline">{capitalize(priceContent)}</span>}/>);
};
export default ExperienceExtra;
